import React from 'react';
import studentImage from '../student.png';

const CommentProfile = () => {
  return (
    <div className="comment-profile">
      <img src={studentImage} alt="student" />
    </div>
  );
};

export default CommentProfile;